module.exports = __webpack_public_path__ + "img/关于我们6.81d2cc8d.png";